console.log("Seller Onboarding JS Loaded");

// Only run on the seller onboarding page
if (window.location.pathname.includes("/pages/safalcart-seller-onboarding")) {
    console.log("Seller onboarding page detected");

    const form = document.getElementById("sellerForm");

    if (!form) {
        console.log("Seller form not found");
    } else {
        form.addEventListener("submit", async (e) => {
            e.preventDefault();
            console.log("Form submitted");

            const data = Object.fromEntries(new FormData(form).entries());
            console.log("Data sending:", data);

            try {
                const response = await fetch(
                    "https://seller-submit-542921875808.asia-south2.run.app",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(data),
                    }
                );

                console.log("Response status:", response.status);
                const result = await response.json();
                console.log("Server response:", result);

                // Mark submission in sessionStorage
                sessionStorage.setItem("sellerFormSubmitted", "true");

                // Redirect to thank-you page
                window.location.href = "/pages/seller-thank-you";

            } catch (err) {
                console.error("Error:", err);
                alert("There was an error submitting the form.");
            }
        });
    }
}

// Optional: Protect the thank-you page from direct access
if (window.location.pathname.includes("/pages/seller-thank-you")) {
    if (!sessionStorage.getItem("sellerFormSubmitted")) {
        document.body.innerHTML = "<h2>Please submit the seller form first.</h2>";
        console.warn("Direct access to thank-you page blocked.");
    } else {
        // Clear the flag so page can't be refreshed to show again without submission
        sessionStorage.removeItem("sellerFormSubmitted");
        console.log("Thank-you page loaded after submission.");
    }
}
